module.exports = __webpack_public_path__ + "img/label_well_platinum.a3360582.png";